/* TODO: t() */
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import Icon, { IconName, IconSize } from './Icon';
import { themeColors } from './Constants';
import Tooltip from './Tooltip';

type Props = {
  iconName: IconName;
  tooltip: string;
  iconSize?: IconSize;
  color?: string;
  style?: StyleSet;
  iconStyle?: StyleSet;
  tooltipStyle?: StyleSet;
  onPress?: () => void;
  isDisabled?: boolean;
};

export default function IconButton(props: Props) {
  let {
    iconName,
    iconSize,
    tooltip,
    iconStyle,

    tooltipStyle,
    style,
    color,
    onPress,
    isDisabled,
  } = props;
  return (
    <View style={styles.root}>
      <Tooltip title={tooltip} style={tooltipStyle}>
        <TouchableOpacity
          activeOpacity={isDisabled ? 0.4 : 0.7}
          onPress={isDisabled ? undefined : onPress}
          style={[style, styles.iconContainer]}
        >
          <Icon
            style={iconStyle}
            size={iconSize ?? 'M'}
            name={iconName}
            color={color ?? themeColors.black}
          />
        </TouchableOpacity>
      </Tooltip>
    </View>
  );
}

let styles = StyleSheet.create({
  root: { width: 32, height: 32, position: 'relative' },
  iconContainer: {
    borderWidth: 1,
    borderColor: themeColors.borderGrey,
    backgroundColor: themeColors.white,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 3,
    width: 32,
    height: 32,
  },
});
